const formatResultDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${month}/${day}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};

function resultCardImg(code) {
    return `/assets/images/cards/${code && code !== "1" ? code : "1"}.svg`;
}

function getCardValue(card) {
    if (!card) return null;
    const value = String(card).slice(0, -2);
    if (value === "A") return 1;
    if (value === "J") return 11;
    if (value === "Q") return 12;
    if (value === "K") return 13;
    return Number(value);
}

function isRed(card) {
    if (!card) return false;
    const suit = String(card).slice(-2);
    return suit === "HH" || suit === "DD";
}

function isNumberCard(card) {
    const value = getCardValue(card);
    return value >= 2 && value <= 10;
}

function isOdd(card) {
    const value = getCardValue(card);
    if (value === null || Number.isNaN(value)) {
        return false;
    }
    return value % 2 !== 0;
}

function isEven(card) {
    const value = getCardValue(card);
    if (value === null || Number.isNaN(value)) {
        return false;
    }
    return value % 2 === 0;
}

const CenterCardResult = ({ resultData }) => {

    return (
        <div className="left-content">

            {resultData?.length > 0 &&
                resultData.map((dataObj, index) => {

                    const leftCard = dataObj.c1;
                    const centerCard = dataObj.c3;
                    const rightCard = dataObj.c2;

                    const markets = [
                        {
                            label: "Left",
                            card: "c1",
                            main: true
                        },
                        {
                            label: "Center",
                            card: "c3",
                            main: true
                        },
                        {
                            label: "Right",
                            card: "c2",
                            main: true
                        },
                        {
                            label: "Center-No",
                            winner: !isNumberCard(centerCard)
                        },
                        {
                            label: "Center-Odd",
                            winner: isOdd(centerCard)
                        },
                        {
                            label: "Left-Even",
                            winner: isEven(leftCard)
                        },
                        {
                            label: "Right-Odd",
                            winner: isOdd(rightCard)
                        },
                        {
                            label: "Center-Red",
                            winner: isRed(centerCard)
                        },
                        {
                            label: "Left-Red",
                            winner: isRed(leftCard)
                        },
                        {
                            label: "Right-Red",
                            winner: isRed(rightCard)
                        }
                    ];

                    console.log("CENTER CARD RESULT:", {
                        left: leftCard,
                        center: centerCard,
                        right: rightCard,

                        centerNo: !isNumberCard(centerCard),
                        centerOdd: isOdd(centerCard),
                        leftEven: isEven(leftCard),
                        rightOdd: isOdd(rightCard),
                        centerRed: isRed(centerCard),
                        leftRed: isRed(leftCard),
                        rightRed: isRed(rightCard)
                    });


                    return (

                        <div
                            key={index}
                            className="card"
                            style={{
                                border: "1px solid rgb(204,204,204)",
                                borderRadius: "8px",
                                padding: "10px",
                                marginBottom: "5px",
                                background:
                                    "linear-gradient(rgb(15,15,15), rgb(251,251,251))",
                                display: "block"
                            }}
                        >
                            <div
                                style={{
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    marginBottom: "12px", marginLeft: "10px", marginTop: "8px"
                                }}
                            >
                                {formatResultDate(dataObj.evt_od)} - <b>ID=</b> {dataObj._id}
                            </div>
                            <div
                                className="card-body"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "0"
                                }}
                            >
                                <div
                                    className="players-table"
                                    style={{
                                        textAlign: "center",
                                        width: "100%"
                                    }}
                                >
                                    <table
                                        style={{
                                            width: "100%",
                                            borderCollapse: "collapse"
                                        }}
                                    >
                                        <tbody>
                                            <tr
                                                style={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    justifyContent: "space-evenly"
                                                }}
                                            >
                                                {markets.map((market) => {
                                                    if (market.main) {
                                                        const cardCode =
                                                            dataObj[market.card];
                                                        return (
                                                            <td
                                                                key={market.label}
                                                                className="TdResults"
                                                            >
                                                                <div
                                                                    className="player-cards"
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        alignItems: "center",
                                                                        overflowWrap: "break-word"
                                                                    }}
                                                                >
                                                                    <div
                                                                        className="player-name"
                                                                        style={{
                                                                            fontWeight: "bold",
                                                                            textAlign: "center",
                                                                            width: "100%"
                                                                        }}
                                                                    >
                                                                        {market.label}
                                                                    </div>
                                                                    <div
                                                                        className="card-images"
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            gap: "3px",
                                                                            flexWrap: "wrap",
                                                                            width: "42%"
                                                                        }}
                                                                    >
                                                                        {cardCode ? (
                                                                            <img
                                                                                src={resultCardImg(cardCode)}
                                                                                alt=""
                                                                            />
                                                                        ) : (
                                                                            <div
                                                                                style={{
                                                                                    width: "45px",
                                                                                    height: "62px"
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                    <div
                                                                        className="player-status bgLoser"
                                                                        style={{
                                                                            color: "#000",
                                                                            marginTop: "5px",
                                                                            fontSize: "14px",
                                                                            fontWeight: "bold",
                                                                            textAlign: "center",
                                                                            width: "100%"
                                                                        }}
                                                                    >
                                                                        LOSER
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        );
                                                    }
                                                    if (!market.winner) {
                                                        return null;
                                                    }
                                                    return (
                                                        <td
                                                            key={market.label}
                                                            className="TdResults"
                                                        >
                                                            <div
                                                                className="player-cards"
                                                                style={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "center",
                                                                    overflowWrap: "break-word",
                                                                    background: "#008000",
                                                                    borderRadius: "10px",
                                                                    overflow: "hidden"
                                                                }}
                                                            >
                                                                <div
                                                                    className="player-name"
                                                                    style={{
                                                                        fontWeight: "bold",
                                                                        textAlign: "center",
                                                                        width: "100%",
                                                                        color: "#fff"
                                                                    }}
                                                                >
                                                                    {market.label}
                                                                </div>
                                                                <div
                                                                    className="card-images"
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        minHeight: "65px",
                                                                        width: "100%"
                                                                    }}
                                                                >
                                                                    <img
                                                                        src="/assets/images/cards/1.svg"
                                                                        alt=""
                                                                        style={{
                                                                            width: "45px"
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div
                                                                    className="player-status bgwinner"
                                                                    style={{
                                                                        background: "#cf8d2e",
                                                                        color: "#000",
                                                                        marginTop: "5px",
                                                                        fontSize: "14px",
                                                                        fontWeight: "bold",
                                                                        textAlign: "center",
                                                                        width: "100%"
                                                                    }}
                                                                >
                                                                    WINNER
                                                                </div>
                                                            </div>
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};


export default CenterCardResult;